<template>
  <div>
    <div class="payment_bloc">
        <div class="columns-12 w-row">
          <div class="column-37 w-col w-col-4 w-col-stack w-col-small-small-stack w-col-tiny-tiny-stack">
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-11">
                <h1 class="heading-7">{{$t('YOUR_MOTOR')}}</h1>
              </div>
              <div class="sum_column w-col w-col-1"><img src="@/assets/images/noun_edit_258785asdasd.svg" class="cursor-pointer" loading="lazy" width="24" alt="" @click="goToStep(1)"></div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('REGISTRATION_NUMBER')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{data.CS_VEHICLE.LICENSE_PLATE}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('MANUFACTURER')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'MANUFACTURER'), data.CS_VEHICLE.MANUFACTURER)}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('MODEL')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{ $h.getFromList($h.getLov(data.ET_LOVS, 'MODEL'), data.CS_VEHICLE.MODEL)}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('MANUFACTURE_YEAR')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{data.CS_VEHICLE.MANUFACTURE_YEAR}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('ENGINE_CAPACITY')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{data.CS_VEHICLE.ENGINE_CAPACITY}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('SEATS')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'NO_OF_SEATS'), data.CS_VEHICLE.NO_OF_SEATS)}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('VEHICLE_VALUE')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$u.formatMoney(data.CS_VEHICLE.VEHICLE_VALUE)}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('IS_CONVERTIBLE')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'YES_NO'), data.CS_VEHICLE.CONVERTIBLE_VEHICLE)}}</p>
              </div>
            </div>
          </div>
          <div class="w-col w-col-4 w-col-stack w-col-small-small-stack w-col-tiny-tiny-stack">
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-11">
                <h1 class="heading-7">{{$t('DRIVERS')}}</h1>
              </div>
              <div class="sum_column w-col w-col-1"><img src="@/assets/images/noun_edit_258785asdasd.svg" class="cursor-pointer" loading="lazy" width="24" alt="" @click="goToStep(2)"></div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('DRIVERS_NUMBER')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'NO_OF_DRIVERS'), data.CS_DRIVERS.NO_OF_DRIVERS)}}</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('OWNER_LICENSE')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'DRIVER_LICENSE_YEAR'), data.CS_DRIVERS.DRIVER_LICENSE_YEAR)}} χρόνια</p>
              </div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{$t('DISTRICT_LIVING')}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <p class="paragraph-4">{{$h.getFromList($h.getLov(data.ET_LOVS, 'DISTRICT'), data.CS_DRIVERS.DISTRICT)}}</p>
              </div>
            </div>
          </div>
          <div class="w-col w-col-4 w-col-stack w-col-small-small-stack w-col-tiny-tiny-stack">
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-11">
                <h1 class="heading-7">{{$t('YOUR_PACKAGE')}}</h1>
              </div>
              <div class="sum_column w-col w-col-1"><img src="@/assets/images/noun_edit_258785asdasd.svg" class="cursor-pointer" loading="lazy" width="24" alt="" @click="goToStep(3)"></div>
            </div>
            <div class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <h1 class="heading-8">{{getSelectedPackage.PACKAGE_DESC}}</h1>
              </div>
              <div class="sum_column w-col w-col-5">
                <div class="package_feature_bullet"></div>
              </div>
            </div>
            <div v-for="cover in getSelectedPackageCovers" :key="cover.COVER_ID" class="summary_grid w-row">
              <div class="sum_column w-col w-col-7">
                <p class="bold_label">{{cover.COVER_DESC}}</p>
              </div>
              <div class="sum_column w-col w-col-5">
                <div class="package_feature_bullet"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="packaging_coverings_area w-row">
          <div class="column-24 w-col w-col-6"></div>
          <div class="column-23 w-col w-col-6">
            <button type="button" class="button_extra_small w-button" @click="goToStep(4)">{{$t('ANALYTIC')}}</button>
          </div>
        </div>
      </div>
      <div class="cta_offer_block">
        <div class="form-block-5 w-form">
          <!-- <form id="email-form" name="email-form" data-name="Email Form" class="form-5"> -->
            <div class="columns-11 w-row">
              <div class="w-col w-col-9 w-col-stack">
                <p class="bold_label paragraph_offer">{{$t('AFTER_PURCHASE_CANCELLATION')}}</p>
              </div>
              <div class="column-38 w-col w-col-3 w-col-stack">
                <button type="button" class="cover_submit_button w-button" @click="payment">{{$t('PAYMENT')}} {{$u.formatMoney(getSelectedPackage.AMOUNT)}}</button>
              </div>
            </div>
          <!-- </form> -->
        </div>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getSelectedPackage() {
      return this.data.CT_PACKAGES.filter((o) => o.ZZSELECTED_IND)[0];
    },
    getSelectedPackageCovers() {
      return this.data.CT_COVERS.filter((o) => (o.PACKAGE_ID === this.getSelectedPackage.PACKAGE_ID && o.ZZMANDATORY_IND) || (o.PACKAGE_ID === this.getSelectedPackage.PACKAGE_ID && !o.ZZMANDATORY_IND && o.ZZSELECTED_IND));
    }
  },
  methods: {
    goToStep(step) {
      this.$emit('select-step', step);
    },
    payment() {
      this.$emit('payment');
    }
  }
};
</script>
